export const QUERY_PARAMS = {
  regionId: 'region_id',
  MARKETING: {
    campaignId: 'iterable_campaign',
  },
  CONFIRMATION: {
    orderId: 'orderId',
    registrationToken: 'registration_token',
    membershipCreditRedemption: 'membershipCreditRedemption',
    creditRedeemed: 'creditRedeemed',
    referral: 'referral',
  },
};

// Region IDs configured in Google Merchant Center, passed
// in via the region_id param appended by the shopping feed
export const REGION_IDS = {
  NEW_YORK: 123456,
};
